import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { filter, Observable, of } from 'rxjs';

import { Store } from '@ngrx/store';

import { selectChatState, selectUser } from '../../../store/app.selectors';

import { skipMessagingKey } from '../../../core/services/http.context';
import { MessagingEnvironmentService } from '../../../core/services/messaging-environment.service';
import { IUserProfile } from '../../user/interfaces/IUserProfile';
import { IChannel } from '../interfaces/IChannel';
import { IMessageTemplate } from '../interfaces/IMessageTemplate';
import { WorkspaceFeatures } from '../interfaces/IWorkspace';
import { AppStateWithChat } from '../store/chat.reducer';
import { PermissionsService } from './permissions.service';

@Injectable()
export class NotificationsApiService {
  selectedChannel: IChannel | null = null;
  user: IUserProfile | null = null;
  messagesTemplates: IMessageTemplate[];
  constructor(
    private httpClient: HttpClient,
    private store: Store<AppStateWithChat>,
    private env: MessagingEnvironmentService,
    private permissionsService: PermissionsService
  ) {
    this.setChatSubscriptions();
    this.setUserSubscriptions();
  }

  setChatSubscriptions(): void {
    this.store
      .select(selectChatState)
      .pipe(filter((data) => data !== undefined))
      .subscribe(({ selectedChannel, messagesTemplates }) => {
        this.selectedChannel = selectedChannel;
        this.messagesTemplates = messagesTemplates;
      });
  }

  setUserSubscriptions(): void {
    this.store.select(selectUser).subscribe((user) => {
      this.user = user;
    });
  }

  getMessagesTemplates(channel: IChannel): Observable<IMessageTemplate[]> {
    if (
      !this.permissionsService.checkWorkspaceFeatures([WorkspaceFeatures.canUseMesagesTemplates]) ||
      this.messagesTemplates?.length ||
      channel.enabled ||
      channel.isBotMode
    ) {
      return of(this.messagesTemplates);
    }
    return this.httpClient.get<IMessageTemplate[]>(
      `${this.env.env.notificationApi}/whatsapp/subAccountDealerId/${this.user?.subAccountMessageableEntity?.businessReference?.entityUID}/simpleList?type=TEMPLATE`,
      {
        context: skipMessagingKey(),
      }
    );
  }
}
